export function roundUpToNextStep(value: number): number {
  if (value <= 0) return value;

  const magnitude = Math.pow(10, Math.floor(Math.log10(value)));
  let step: number;

  if (value < 100) {
    step = 20;
  } else if (value < 500) {
    step = 150;
  } else if (value < 1000) {
    step = 500;
  } else {
    step = magnitude / 2;
  }

  console.log("redondeo de ", value, " a ", Math.ceil(value / step) * step);
  return Math.ceil(value / step) * step;
}


export function nextRoundTens(num: number) {
  if(num == 0) { num = 0.1; }

  if(num <= 10){
    return Math.ceil(num * 1.2)
  }
  return Math.ceil(num / 10) * 10;
}
